import { IVideoMetaData } from 'app/shared/model/video-meta-data.model';

export interface IVideoMetaDataKeywords {
  id?: number;
  keywordName?: string;
  videoMetaData?: IVideoMetaData;
}

export const defaultValue: Readonly<IVideoMetaDataKeywords> = {};
